import React from "react";
import PropTypes from "prop-types";
import TextInput from "./TextInput";
import { Alert } from "reactstrap";
import { Formik, Form, Field } from "formik";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import Paginator from "react-ultimate-pagination-bootstrap-4";
import Button from "./CustomButton";

export const SingleTextForm = props => {
  const {
    icon,
    action,
    name,
    placeholder,
    label,
    failSubmit,
    submitting,
    onSubmit,
    initialValues,
    showPagination,
    totalPages,
    currentPage,
    onPageChange
  } = props;
  return (
    <Formik
      onSubmit={onSubmit}
      initialValues={initialValues}
      render={({ values }) => (
        <Form>
          {failSubmit && <Alert color="danger">{failSubmit}</Alert>}
          <div className="row align-items-start">
            <div className="col-lg-6 px-sm-1">
              <Field
                name={name}
                component={TextInput}
                placeholder={placeholder}
                label={label}
              />
            </div>
            <div className="col-lg-3 px-sm-1">
              <Field
                name="cust_identifier"
                component={TextInput}
                placeholder="Customer identifier"
              />
            </div>
            <div className="col-lg-3 px-sm-1 mb-2">
              <Button
                block
                fill
                type="submit"
                disabled={submitting}
                color="primary"
              >
                {action} {icon && <FontAwesomeIcon icon={icon} />}
              </Button>
            </div>
          </div>
          {showPagination && (
            <div className="row">
              <div className="col px-md-1">
                <Paginator
                  totalPages={totalPages}
                  currentPage={currentPage}
                  onChange={onPageChange(values)}
                />
              </div>
            </div>
          )}
        </Form>
      )}
    />
  );
};

SingleTextForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  failSubmit: PropTypes.string,
  initialValues: PropTypes.object.isRequired,
  icon: PropTypes.object,
  action: PropTypes.string,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string.isRequired
};

SingleTextForm.defaultProps = {
  action: "Send"
};

export default SingleTextForm;
